













































import { Component, ComponentStyle, ComponentStyleDefinition, Answer, Prop, Vue } from "@zoovu/runner-browser-api";

import { FilterDropDownQuestionView } from "@zoovu/runner-web-design-base";
import Vuebar from "vuebar";
import { IconChevron } from "./svgs";

Vue.use(Vuebar);

@Component({
  components: { IconChevron },
  name: "FilterDropDownQuestionView",
  mixins: [FilterDropDownQuestionView],
})
export default class FilterDropDownQuestionViewExtended extends Vue {
  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @Prop()
  private showDisabledAnswers: boolean;

  @Prop()
  private hideOptionLabels: boolean;

  dropdownOpened = true;

  get doesSomeAnswerHaveImage(): boolean {
    return this.question.answers.some((answer) => answer.images && answer.images.length > 0);
  }

  get componentStateClasses(): Record<string, unknown> {
    return {
      "has-image": this.doesSomeAnswerHaveImage,
      "no-labels": this.hideOptionLabels,
    };
  }

  shouldBeShown(answer: Answer): boolean {
    return answer && (!answer.disabled || this.showDisabledAnswers);
  }

  showImage = (answer: Answer): boolean => {
    return answer.images != null && answer.images[0] != null;
  };
}
